<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="headline">Datos del colegio</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex d-flex>
              <v-layout align-center>
                <v-select label="Tipo de colegio" name="tipo_colegio" id="tipo_colegio" :items="tiposColegio" v-model="registro.tipo" :rules="requeridoRegla" item-text="nombre" item-value="id" return-object v-bind:readonly="disabledRegistro"/>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex d-flex>
              <v-layout align-center>
                <v-text-field label="Nombre" v-model="registro.nombre" :rules="requeridoRegla" v-bind:readonly="disabledRegistro" v-on:keyup="registro.nombre = registro.nombre.toUpperCase();"></v-text-field>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex d-flex>
              <v-layout align-center>
                <v-text-field label="Director(a)" v-model="registro.director" :rules="requeridoRegla" v-bind:readonly="disabledRegistro" v-on:keyup="registro.director = registro.director.toUpperCase();"></v-text-field>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex d-flex>
              <v-layout align-center>
                <v-text-field label="Dirección" v-model="registro.direccion" :rules="requeridoRegla" v-bind:readonly="disabledRegistro" v-on:keyup="registro.direccion = registro.direccion.toUpperCase();"></v-text-field>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex d-flex>
              <v-layout align-center>
                <v-text-field label="Teléfono" v-model="registro.telefono" :rules="requeridoRegla" v-bind:readonly="disabledRegistro" mask="##############"></v-text-field>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex d-flex>
              <v-layout align-center>
                <v-text-field label="Correo Electrónico" v-model="registro.correo" :rules="emailRegla" v-bind:readonly="disabledRegistro" v-on:keyup="registro.correo = registro.correo.toUpperCase();"></v-text-field>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex d-flex>
              <v-layout align-center>
                <v-select label="Sede" name="sede" id="sede" v-model="registro.sede" :items="sedes" item-text="nombre" item-value="id" return-object :rules="requeridoRegla" v-bind:readonly="disabledRegistro"/>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex d-flex>
              <v-layout align-center>
                <v-text-field label="RUC" v-model="registro.ruc" :rules="rucRegla" v-bind:readonly="disabledRegistro" maxlength = "11"></v-text-field>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="disabledRegistro = !disabledRegistro" v-if="disabledRegistro">Editar</v-btn>
        <v-btn color="primary" @click.native="guardar" v-if="!disabledRegistro">Guardar</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
</div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  data: () => ({
    dialog: false,
    disabledRegistro: false,
    totalRegistros: 0,
    loading: false,
    pagination: {},
    menu: false,
    cierreFecha: null,
    headers: [
      { text: 'Apellido paterno', value: 0 },
      { text: 'Apellido materno', value: 1 },
      { text: 'Nombres', value: 2 },
      { text: 'DNI', value: 3 },
      { text: 'Teléfono', value: 4 },
      { text: 'Correo', value: 5 },
      { text: 'Colegio', value: 6 },
      { text: 'Grado', value: 7 },
      { text: 'Actions', align: 'center', value: '', sortable: false }
    ],
    tiposColegio: [
      {id: 'E', nombre: 'ESTATAL'},
      {id: 'P', nombre: 'PRIVADO'}
    ],
    sedes: [
      {id: '1', nombre: 'PUNO'},
      {id: '2', nombre: 'JULIACA'},
      {id: '3', nombre: 'ILAVE'}
    ],
    datos: [],
    registro: {},
    requeridoRegla: [
      v => !!v || 'Requerido'
      // v => (v && v.length <= 10) || 'Name must be less than 10 characters'
    ],
    emailRegla: [
      v => !!v || 'Correo es requerido',
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Correo debe ser válido'
    ]
  }),
  computed: {
    computedCierreFecha () {
      return this.formatoFecha(this.registro.cierreFecha)
    },
    registroTotal () {
      var total = 0
      if (this.registro.cierreBilletes200) total += parseFloat(this.registro.cierreBilletes200)
      if (this.registro.cierreBilletes100) total += parseFloat(this.registro.cierreBilletes100)
      if (this.registro.cierreBilletes50) total += parseFloat(this.registro.cierreBilletes50)
      if (this.registro.cierreBilletes20) total += parseFloat(this.registro.cierreBilletes20)
      if (this.registro.cierreBilletes10) total += parseFloat(this.registro.cierreBilletes10)
      if (this.registro.cierreMonedas) total += parseFloat(this.registro.cierreMonedas)
      return total
    }
  },
  watch: {
    dialog (val) {
      val || this.cerrar()
    },
    'registro.cierreFecha' (val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha)
    },
    pagination: {
      handler () {
        if (this.loading === false) {
          let descendente = 0
          if (this.pagination.descending) {
            descendente = 1
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
        }
      },
      deep: true
    }
  },
  created () {
    this.initialize()
    if (this.login === false) {
      this.$router.push('/Ingresar')
    }
    this.verRegistro()
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    apiListaRegistros (idx, ord, pagina) {
      var solicitudApi = this.crearSolicitud()
      if (this.datos.pagina === undefined) {
        pagina = 0
      }
      this.loading = true
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      }
      solicitudApi.datos = datos
      const myRequest = new Request(`${process.env.API}inicio.php?mod=colegio&accion=listar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.datos = datos.d
            this.totalRegistros = this.datos.registros
            if (parseInt(this.datos.pagina) !== parseInt(this.pagination.page)) {
              this.pagination.page = parseInt(this.datos.pagina)
            }
            this.loading = false
          }
        })
    },
    setTotal: function (total) {
      this.registro.comprobanteTotal = total
    },
    verRegistro () {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = []
      const myRequest = new Request(`${process.env.API}inicio.php?mod=colegio&accion=ver`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.registro = datos.d
            this.disabledRegistro = true
          }
        })
    },
    nuevoRegistro () {
      this.verRegistro({fila: [0]})
    },
    cerrar () {
      this.dialog = false
      setTimeout(() => {
      }, 300)
    },
    guardar () {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.API}inicio.php?mod=colegio&accion=guardar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.verRegistro()
              this.disabledRegistro = true
            }
          }
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Colegio.vue